import { render, staticRenderFns } from "./UserCouponCreate.vue?vue&type=template&id=7b20e97a&scoped=true"
import script from "./UserCouponCreate.vue?vue&type=script&lang=js"
export * from "./UserCouponCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b20e97a",
  null
  
)

export default component.exports